/**
 * Generated runtime TestId mirror for frontend/src/pages/ErrorLogDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const ErrorLogDetailTestIds = {
  actionIdValue: "action-id-value",
  authUsernameValue: "auth-username-value",
  btnCopyCorrelationId: "btn-copy-correlation-id",
  btnCopyTrace: "btn-copy-trace",
  btnToggleHeaders: "btn-toggle-headers",
  cardTitleOccurrenceContext: "card-title-occurrence-context",
  cardTitleOccurrences: "card-title-occurrences",
  cardTitleRequestContext: "card-title-request-context",
  cardTitleStackTrace: "card-title-stack-trace",
  colContext: "col-context",
  colMessage: "col-message",
  colSourceEntity: "col-source-entity",
  colTime: "col-time",
  e2eRunIdValue: "e2e-run-id-value",
  e2eTestClassValue: "e2e-test-class-value",
  e2eTestMethodValue: "e2e-test-method-value",
  errorLogDetailPage: "error-log-detail-page",
  headersContent: "headers-content",
  occurrenceContext: "occurrence-context",
  occurrencesCard: "occurrences-card",
  occurrencesTable: "occurrences-table",
  patternDetailPage: "pattern-detail-page",
  patternInfo: "pattern-info",
  patternStacktrace: "pattern-stacktrace",
  requestContextCard: "request-context-card",
  requestSourceBadge: "request-source-badge",
  sessionIdLink: "session-id-link",
  sessionIdValue: "session-id-value",
  stacktracePre: "stacktrace-pre",
  userAgentValue: "user-agent-value",
  occurrenceRow: (occ_errorLogId: string) => `occurrence-row-${occ_errorLogId}`,
  occurrenceRowPrefix: () => "occurrence-row-" as TestIdPrefix
} as const;
